var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// src/components/tes-create-run/definition/tesCreateRun.ts
import {
  FASTElement,
  attr,
  observable,
  customElement
} from "@microsoft/fast-element";

// src/components/tes-create-run/definition/tesCreateRun.template.ts
import { html, repeat, when } from "@microsoft/fast-element";
import {
  provideFASTDesignSystem,
  fastTextField,
  fastSwitch,
  fastButton,
  fastDivider,
  fastAccordion,
  fastAccordionItem
} from "@microsoft/fast-components";
provideFASTDesignSystem().register(
  fastTextField(),
  fastSwitch(),
  fastButton(),
  fastDivider(),
  fastAccordion(),
  fastAccordionItem()
);
var ExecutorsTemplate = html`
  ${repeat(
  (x) => x.taskExecutors,
  html`
      <div class="executors">
        <div class="label-input commands">
          <label for="command">Command:</label>
          <fast-text-field
            type="text"
            id="command"
            name="command"
            class="input"
            :value=${(x) => x.command.join(",")}
            @input=${(x, c) => c.parent.handleExecutorsCommandChange(c.event, x)}
            required
          ></fast-text-field>
        </div>
        <div class="label-input image">
          <label for="command">Image:</label>
          <fast-text-field
            type="text"
            id="image"
            name="image"
            class="input"
            :value=${(x) => x.image}
            @input=${(x, c) => c.parent.handleExecutorsDataChange(c.event, x)}
            required
          ></fast-text-field>
        </div>
        <div class="container env-container">
          <span class="data-button">
            <fast-button
              class="add"
              id="add-env"
              @click=${(x, c) => c.parent.addEnv(x)}
            >
              Add Env
            </fast-button>
          </span>
          <div class="env">
            ${repeat(
    (x) => Array.from(Array(Object.keys(x.env).length).keys()),
    html` <div class="label-input env-name">
                  <label for="env-name">Env${(x) => x + 1} Name:</label>
                  <fast-text-field
                    type="text"
                    id="env-name"
                    name="env-name"
                    class="input"
                    :value=${(x, c) => Object.keys(c.parent.env)[x]}
                    @input=${(x, c) => c.parentContext.parent.handleEnvNameChange(
      c.event,
      c.parent,
      x
    )}
                  ></fast-text-field>
                </div>
                <div class="label-input env-value">
                  <label for="env-value">Env${(x) => x + 1} Value:</label>
                  <fast-text-field
                    type="text"
                    id="env-value"
                    name="env-value"
                    :value=${(x, c) => Object.values(c.parent.env)[x]}
                    class="input"
                    @input=${(x, c) => c.parentContext.parent.handleEnvValueChange(
      c.event,
      c.parent,
      x
    )}
                  ></fast-text-field>
                </div>`
  )}
          </div>
          ${when(
    (x) => Object.keys(x.env).length,
    html`<span class="data-button">
              <fast-button
                class="delete"
                id="delete-env"
                @click=${(x, c) => c.parent.deleteEnv(x)}
              >
                Delete Env
              </fast-button>
            </span>`
  )}
        </div>
        <div class="label-input stderr">
          <label for="stderr">Stderr:</label>
          <fast-text-field
            type="text"
            id="stderr"
            name="stderr"
            class="input"
            :value=${(x) => x.stderr}
            @input=${(x, c) => c.parent.handleExecutorsDataChange(c.event, x, c)}
          ></fast-text-field>
        </div>
        <div class="label-input stdin">
          <label for="stdin">Stdin:</label>
          <fast-text-field
            type="text"
            id="stdin"
            name="stdin"
            class="input"
            :value=${(x) => x.stdin}
            @input=${(x, c) => c.parent.handleExecutorsDataChange(c.event, x)}
          ></fast-text-field>
        </div>
        <div class="label-input stdout">
          <label for="stdout">Stdout:</label>
          <fast-text-field
            type="text"
            id="stdout"
            name="stdout"
            class="input"
            :value=${(x) => x.stdout}
            @input=${(x, c) => c.parent.handleExecutorsDataChange(c.event, x)}
          ></fast-text-field>
        </div>
        <div class="label-input workdir">
          <label for="workdir">Workdir:</label>
          <fast-text-field
            type="text"
            id="workdir"
            name="workdir"
            class="input"
            :value=${(x) => x.workdir}
            @input=${(x, c) => c.parent.handleExecutorsDataChange(c.event, x)}
          ></fast-text-field>
        </div>
      </div>
    `,
  { positioning: true }
)}
`;
var InputTemplate = html`
  ${repeat(
  (x) => x.taskInput,
  html`
      <div class="inputs">
        <div class="label-input input-path">
          <label for="name">Path:</label>
          <fast-text-field
            type="text"
            id="input-path"
            name="input-path"
            class="input"
            :value=${(x) => x.path}
            @input=${(x, c) => c.parent.handleInputPathChange(c.event, x)}
          ></fast-text-field>
        </div>
        <div class="label-input input-url">
          <label for="name">URL:</label>
          <fast-text-field
            type="text"
            id="input-url"
            name="input-url"
            class="input"
            :value=${(x) => x.url}
            @input=${(x, c) => c.parent.handleInputUrlChange(c.event, x)}
          ></fast-text-field>
        </div>
      </div>
    `
)}
`;
var OutputTemplate = html`
  ${repeat(
  (x) => x.taskOutput,
  html`
      <div class="outputs">
        <div class="label-input output-path">
          <label for="name">Path:</label>
          <fast-text-field
            type="text"
            id="output-path"
            name="output-path"
            class="input"
            :value=${(x) => x.path}
            @input=${(x, c) => c.parent.handleOutputPathChange(c.event, x)}
          ></fast-text-field>
        </div>
        <div class="label-input output-url">
          <label for="name">URL:</label>
          <fast-text-field
            type="text"
            id="output-url"
            name="output-url"
            class="input"
            :value=${(x) => x.url}
            @input=${(x, c) => c.parent.handleOutputUrlChange(c.event, x)}
          ></fast-text-field>
        </div>
        <div class="label-input output-type">
          <label for="name">Type:</label>
          <fast-text-field
            type="text"
            id="output-type"
            name="output-type"
            class="input"
            :value=${(x) => x.type}
            @input=${(x, c) => c.parent.handleOutputTypeChange(c.event, x)}
          ></fast-text-field>
        </div>
      </div>
    `
)}
`;
var template = html`
  ${when(
  (x) => x.responseGot && x.reponseHas("id"),
  html`
      <ecc-client-ga4gh-tes-run
        baseUrl=${(x) => x.baseURL}
        id=${(x) => x.response.id}
      >
      </ecc-client-ga4gh-tes-run>
      <!-- Submit Button -->
      <div class="submit-button-container">
        <fast-button class="submit-button" @click=${(x) => x.fillFormAgain()}
          >Fill Form Again
        </fast-button>
      </div>
    `
)}
  ${when(
  (x) => x.responseGot && x.reponseHas("error"),
  html`
      <fast-accordion-item>
        <span slot="start">error: ${(x) => x.response.error} </span>
        <p>${(x) => JSON.stringify(x.response)}</p>
      </fast-accordion-item>
      <!-- Submit Button -->
      <div class="submit-button-container">
        <fast-button class="submit-button" @click=${(x) => x.fillFormAgain()}
          >Fill Form Again
        </fast-button>
      </div>
    `
)}
  ${when(
  (x) => !x.responseGot,
  html`
<form class="form-container" >
  <!-- Meta data  -->
  <div class="container meta">
    <div class="label-input">
      <label for="name">Name:</label>
      <fast-text-field type="text" id="name" name="name" class="input" :value=${(x) => x.name} @input=${(x, c) => x.handleDataChange(c.event)} >
      </div>
        <div class="label-input">
          <label for="description">Description:</label>
          <fast-text-field type="text" id="description" name="description" class="input" :value=${(x) => x.description}
         @input=${(x, c) => x.handleDataChange(c.event)} >
        </div>
      </div>

      <!-- Executors Fields -->
      <fast-accordion>
   <div class="container executors-container">
         <fast-accordion-item expanded>
            <h3 slot="start">Executors</h3>
            <div class="data-button">
               <fast-button class="add" id="add-executors" @click=${(x) => x.addExecutor()} > Add Executor
               </fast-button>
            </div>
            ${ExecutorsTemplate}
            ${when(
    (x) => x.taskExecutorsLength > 1,
    html`
                <div class="data-button">
                  <fast-button
                    class="delete"
                    id="delete-executor"
                    @click=${(x) => x.deleteExecutor()}
                  >
                    Delete Executor
                  </fast-button>
                </div>
              `
  )}
         </fast-accordion-item>
   </div>

   <!-- Input Fields -->
   <div class="container input-container">
         <fast-accordion-item>
            <h3 slot="start">Inputs</h3>
            <span class="data-button">
               <fast-button class="add" id="add-input" @click=${(x) => x.addInput()}> Add Input
               </fast-button>
            </span>
            ${InputTemplate}
            ${when(
    (x) => x.taskInputLength > 1,
    html`
                <span class="data-button">
                  <fast-button
                    class="delete"
                    id="delete-input"
                    @click=${(x) => x.deleteInput()}
                  >
                    Delete Input
                  </fast-button>
                </span>
              `
  )}
            </fieldset>
         </fast-accordion-item>
   </div>

   <!-- Output Fields -->
   <div class="container output-container">
         <fast-accordion-item>
            <h3 slot="start">Outputs</h3>
            <span class="data-button">
               <fast-button class="add" id="add-output" @click=${(x) => x.addOutput()} > Add Output
               </fast-button>
            </span>
            ${OutputTemplate}
            ${when(
    (x) => x.taskOutputLength > 1,
    html`
                <span class="data-button">
                  <fast-button
                    class="delete"
                    id="delete-output"
                    @click=${(x) => x.deleteOutput()}
                  >
                    Delete Output
                  </fast-button>
                </span>
              `
  )}
            </fieldset>
         </fast-accordion-item>
   </div>

   <!-- Resources Fields -->
   <div class="container resources-container">
         <fast-accordion-item>
            <h3 slot="start">Resources</h3>
            <div class="resources">
               <div class="label-input">
                  <label for="cpu_cores">CPU Cores:</label>
                  <fast-text-field type="text" id="cpu_cores" name="cpu_cores" class="input" :value=${(x) => x.cpu_cores} @input=${(x, c) => x.handleDataChange(c.event)} >
               </div>
               <div class="label-input">
                  <label for="disk_gb">Disk GB:</label>
                  <fast-text-field type="text" id="disk_gb" name="disk_gb" class="input" :value=${(x) => x.disk_gb} @input=${(x, c) => x.handleDataChange(c.event)} >
               </div>
               <div class="label-input">
                  <label for="ram_gb">RAM GB:</label>
                  <fast-text-field type="text" id="ram_gb" name="ram_gb" class="input" :value=${(x) => x.ram_gb} @input=${(x, c) => x.handleDataChange(c.event)} >
               </div>
               <div class="label-input">
                  <label for="zones">Zones:</label>
                  <fast-text-field type="text" id="zones" name="zones" class="input" :value=${(x) => x.zones.join(",")} @input=${(x, c) => x.handleZonesInput(c.event)} >
               </div>
               <div class="label-input">
                  <label for="preemptible">Preemtible</label>
                  <fast-switch id="preemptible" name="preemptible" class="checkbox-field" @change=${(x, c) => x.handlePreemptibleInput(c.event)}></fast-switch>
               </div>
            </div>
         </fast-accordion-item>
   </div>

   <!-- Tags Fields -->
   <div class="container tags-container">
      <fast-accordion-item>
      <h3 slot="start">Tags</h3>
      <div class="tags">
         <div class="label-input">
            <label for="workflow_id">Workflow ID:</label>
            <fast-text-field type="text" id="workflow_id" name="workflow_id" class="input" :value=${(x) => x.WORKFLOW_ID} @input=${(x, c) => x.handleDataChange(c.event)} >
         </div>
         <div class="label-input">
            <label for="project_group">Project Group:</label>
            <fast-text-field type="text" id="project_group" name="project_group" class="input" :value=${(x) => x.PROJECT_GROUP} @input=${(x, c) => x.handleDataChange(c.event)} >
         </div>
      </div>
      </fast-accordion-item>
   </div>

   <!-- Volumes Fields -->
   <div class="container volumes">
         <fast-accordion-item>
            <h3 slot="start">Volumes</h3>
            <div class="label-input">
               <label for="volumes">Volumes:</label>
               <fast-text-field type="text" id="volumes" name="volumes" class="input" :value=${(x) => x.volumes.join(",")} @input=${(x, c) => x.handleVolumesInput(c.event)} required >
         </fast-accordion-item>
      </div>
   </div>
   </fast-accordion>

   <!-- Submit Button -->
   <div class="submit-button-container">
     ${when(
    (x) => x.isLoading,
    html`
         <fast-button
           class="submit-button"
           @click=${(x) => x.handleSubmit()}
           disabled=${(x) => x.isLoading}
         >
           ${when((x) => x.isLoading, html`Creating task`)}
         </fast-button>
       `
  )}
      ${when(
    (x) => !x.isLoading,
    html` <fast-button
          class="submit-button"
          @click=${(x) => x.handleSubmit()}
          }
        >
          ${when((x) => !x.isLoading, html`Create Task`)}
        </fast-button>`
  )}
   </div>
  </form>
  `
)}
`;
var tesCreateRun_template_default = template;

// src/components/tes-create-run/definition/tesCreateRun.styles.ts
import { css } from "@microsoft/fast-element";
var styles = css`
  fast-accordion {
    color: black;
  }
  fast-accordion-item {
    color: black;
  }

  /* CSS styles for the form */
  .form-container {
    margin: 0 auto;
    padding: 0.4rem;
  }

  /* All the CSS that deals with labe and input field */
  .label-input {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.4rem;
  }

  label {
    width: 100px;
  }

  fast-text-field {
    width: 50%;
  }

  .executors,
  .env,
  .inputs,
  .outputs,
  .resources,
  .tags {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .env-container {
    grid-column: 1 / span 2;
  }

  .data-button {
    display: flex;
    justify-content: end;
  }

  fast-button {
    height: 1.8rem;
  }

  .add:hover {
    background-color: #4caf50;
  }

  .delete:hover {
    background-color: #d32f2f;
  }

  .submit-button-container {
    display: flex;
    justify-content: center;
    margin-top: 0.6em;
  }

  .submit-button {
    height: 2.5rem;
  }

  .submit-button:hover {
    background-color: #4caf50;
  }

  .submit-button:active {
    background-color: #4ccf50;
  }

  /* Media query for screens with a maximum width of 1024px */
  @media (max-width: 1024px) {
    fast-text-field {
      width: 65%;
    }
  }

  /* Media query for screens with a maximum width of 768px */
  @media (max-width: 768px) {
    .form-container {
      padding: 0.2rem;
    }

    .executors,
    .inputs,
    .outputs,
    .resources,
    .tags {
      display: flex;
      flex-direction: column;
    }

    .env-container {
      display: flex;
      flex-direction: column;
    }

    .env {
      display: flex;
      flex-direction: column;
    }
    .submit-button {
      height: 2rem;
    }
  }
`;
var tesCreateRun_styles_default = styles;

// src/data/Task/tesGet.ts
var fetchService = async (baseURL) => {
  const url = `${baseURL}/service-info?`;
  try {
    const response = await fetch(url);
    if (!response) {
      return {
        isError: true,
        breakpoint: "fetchTasks",
        error: "No response from server"
      };
    }
    return await response.json();
  } catch (error) {
    return {
      isError: true,
      breakpoint: "fetchTasks",
      error
    };
  }
};
var fetchTasks = async (baseURL, pageSize = 5, nextPageToken = "", view = "MINIMAL", namePrefix = "") => {
  let url = `${baseURL}/tasks?`;
  if (pageSize) {
    url += `page_size=${pageSize}&`;
  }
  if (view) {
    url += `view=${view}&`;
  }
  if (nextPageToken.length > 0) {
    url += `page_token=${nextPageToken}&`;
  }
  if (namePrefix.length > 0) {
    url += `name_prefix=${namePrefix}&`;
  }
  try {
    const response = await fetch(url);
    if (!response) {
      return {
        isError: true,
        breakpoint: "fetchTasks",
        error: "No response from server"
      };
    }
    return await response.json();
  } catch (error) {
    return {
      isError: true,
      breakpoint: "fetchTasks",
      error
    };
  }
};
var fetchTask = async (baseURL, id) => {
  const url = `${baseURL}/tasks/${id}?view=FULL`;
  try {
    const response = await fetch(url);
    if (!response) {
      return {
        isError: true,
        breakpoint: "fetchTask",
        error: "No response from server"
      };
    }
    return await response.json();
  } catch (error) {
    return {
      isError: true,
      breakpoint: "fetchTask",
      error
    };
  }
};
var deleteTask = async (baseURL, id) => {
  const url = `${baseURL}/tasks/${id}:cancel`;
  try {
    const response = await fetch(url, {
      method: "DELETE"
    });
    return response;
  } catch (error) {
    return {
      isError: true,
      breakpoint: "deleteTask",
      error
    };
  }
};
var postTask = async (baseURL, taskData) => {
  const url = `${baseURL}/tasks`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(taskData)
    });
    if (!response) {
      return {
        isError: true,
        breakpoint: "postTask",
        error: "No response from server"
      };
    }
    return await response.json();
  } catch (error) {
    return {
      isError: true,
      breakpoint: "postTask",
      error
    };
  }
};

// src/components/tes-create-run/definition/tesCreateRun.ts
var executorTemplate = {
  command: [""],
  env: {},
  image: "",
  stderr: "",
  stdin: "",
  stdout: "",
  workdir: ""
};
var inputTemplate = {
  path: "",
  url: ""
};
var outputTemplate = {
  path: "",
  url: "",
  type: ""
};
var TESCreateRun = class extends FASTElement {
  constructor() {
    super(...arguments);
    this.baseURL = "";
    this.name = "";
    this.description = "";
    this.taskExecutors = [{ ...executorTemplate }];
    this.taskExecutorsLength = this.taskExecutors.length;
    this.taskInput = [{ ...inputTemplate }];
    this.taskInputLength = this.taskInput.length;
    this.taskOutput = [{ ...outputTemplate }];
    this.taskOutputLength = 1;
    this.cpu_cores = "";
    this.disk_gb = "";
    this.preemptible = false;
    this.ram_gb = "";
    this.zones = [];
    this.WORKFLOW_ID = "";
    this.PROJECT_GROUP = "";
    this.volumes = [];
    this.response = { id: "id" };
    this.taskData = {
      name: this.name,
      description: this.description,
      executors: this.taskExecutors,
      inputs: this.taskInput,
      outputs: this.taskOutput,
      resources: {
        cpu_cores: this.cpu_cores,
        disk_gb: this.disk_gb,
        preemptible: this.preemptible,
        ram_gb: this.ram_gb,
        zones: this.zones
      },
      tags: {
        WORKFLOW_ID: this.WORKFLOW_ID,
        PROJECT_GROUP: this.PROJECT_GROUP
      },
      volumes: this.volumes
    };
    this.responseGot = false;
    this.isLoading = false;
    this.removeEmptyFields = (obj) => {
      Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          if (value.length === 0) {
            delete obj[key];
          } else {
            value.forEach((element) => {
              if (typeof element === "object" && element !== null) {
                this.removeEmptyFields(element);
              }
            });
            value.forEach((element, index) => {
              if (typeof element === "object" && Object.entries(element).length === 0) {
                value.splice(index, 1);
              }
            });
            if (value.length === 0) {
              delete obj[key];
            }
          }
        } else if (value && typeof value === "object") {
          if (Object.entries(value).length === 0) {
            delete obj[key];
          } else {
            this.removeEmptyFields(value);
            if (Object.entries(value).length === 0) {
              delete obj[key];
            }
          }
        } else if (value === null || value === void 0 || value === "") {
          delete obj[key];
        }
      });
      return obj;
    };
    /**
     * Checks is the reponse of the sumbmission has a specified key
     * @param key The key to be checked in response
     * @returns true is the response has the said key
     */
    this.reponseHas = (key) => {
      if (Object.prototype.hasOwnProperty.call(this.response, key)) {
        return true;
      }
      return false;
    };
    /**
     * Handles submit button click
     */
    this.handleSubmit = async () => {
      this.responseGot = false;
      this.isLoading = true;
      this.setFormDataToDefault();
      this.checkRequiredFields();
      if (Object.prototype.hasOwnProperty.call(this.response, "error")) {
        this.isLoading = false;
        this.responseGot = true;
        this.clearForm();
        return;
      }
      this.removeEmptyFields(this.taskData);
      const isValid = this.isJSONValid(this.taskData);
      if (!isValid) {
        this.response = {
          error: "Invalid JSON form the form data."
        };
        this.responseGot = true;
        this.isLoading = false;
      }
      this.response = await postTask(this.baseURL, this.taskData);
      this.isLoading = false;
      this.responseGot = true;
      console.log(this.response);
      this.clearForm();
    };
    /**
     * Clears all the fields and sets the value to empty
     */
    this.clearForm = () => {
      this.taskData = {
        name: this.name,
        description: this.description,
        executors: this.taskExecutors,
        inputs: this.taskInput,
        outputs: this.taskOutput,
        resources: {
          cpu_cores: this.cpu_cores,
          disk_gb: this.disk_gb,
          preemptible: this.preemptible,
          ram_gb: this.ram_gb,
          zones: this.zones
        },
        tags: {
          WORKFLOW_ID: this.WORKFLOW_ID,
          PROJECT_GROUP: this.PROJECT_GROUP
        },
        volumes: this.volumes
      };
      this.baseURL = "";
      this.name = "";
      this.description = "";
      this.taskExecutors = [{ ...executorTemplate }];
      this.taskInput = [{ ...inputTemplate }];
      this.taskOutput = [{ ...outputTemplate }];
      this.cpu_cores = "";
      this.disk_gb = "";
      this.preemptible = false;
      this.ram_gb = "";
      this.zones = [];
      this.WORKFLOW_ID = "";
      this.PROJECT_GROUP = "";
      this.volumes = [];
      this.setFormDataToDefault();
    };
    /**
     * Set all the form fields to the value of the attr in current state
     */
    this.setFormDataToDefault = () => {
      this.taskData.name = this.name;
      this.taskData.description = this.description;
      this.taskData.executors = this.taskExecutors;
      this.taskData.inputs = this.taskInput;
      this.taskData.outputs = this.taskOutput;
      this.taskData.resources.cpu_cores = this.cpu_cores;
      this.taskData.resources.disk_gb = this.disk_gb;
      this.taskData.resources.preemptible = this.preemptible;
      this.taskData.resources.ram_gb = this.ram_gb;
      this.taskData.resources.zones = this.zones;
      this.taskData.tags.WORKFLOW_ID = this.WORKFLOW_ID;
      this.taskData.tags.PROJECT_GROUP = this.PROJECT_GROUP;
      this.taskData.volumes = this.volumes;
    };
    /**
     * Checks if all the required fields ie command, image, and workdir is filled
     * @returns break and sets response to error message is required fields aren't filled
     */
    this.checkRequiredFields = () => {
      const requiredFields = ["image", "workdir"];
      for (const executor of this.taskData.executors) {
        for (const field of requiredFields) {
          if (!executor[field] || Array.isArray(executor[field]) && executor[field].length === 0) {
            this.response = {
              error: `${field} cannot be left empty`,
              breakpoint: "handleSubmit"
            };
            return;
          }
        }
      }
    };
    /**
     * Handles the input for the data thats non-dynamic, ie only of is present.
     * @param event The input event triggered when the disk-gb input changes
     */
    this.handleDataChange = (event) => {
      const { name } = event.target;
      const { value } = event.target;
      switch (name) {
        case "name":
          this.name = value;
          break;
        case "description":
          this.description = value;
          break;
        case "cpu_cores":
          this.cpu_cores = value;
          break;
        case "disk_gb":
          this.disk_gb = value;
          break;
        case "ram_gb":
          this.ram_gb = value;
          break;
        case "workflow_id":
          this.WORKFLOW_ID = value;
          break;
        case "project_group":
          this.PROJECT_GROUP = value;
          break;
        default:
          break;
      }
    };
    this.fillFormAgain = () => {
      this.responseGot = false;
      this.clearForm();
      this.response = {};
    };
    /**
     * Handles the zones input for the task
     * - zones - Request that the task be run in these compute zones
     * @param event The input event triggered when the zones input changes
     */
    this.handleZonesInput = (event) => {
      const inputElement = event.target;
      this.zones = inputElement.value.split(",").map((volume) => volume.trim());
    };
    /**
     * Handles the preemptible input for the task
     * - preemptible - Define if the task is allowed to run on
     *  preemptible compute instances, for example, AWS Spot
     * @param event The input event triggered when the preemptible input changes
     */
    this.handlePreemptibleInput = (event) => {
      if (event.target.getAttribute("aria-checked") === "true") {
        this.preemptible = true;
      } else {
        event.target.setAttribute("aria-checked", "true");
        this.preemptible = false;
      }
    };
    /**
     * Handles the volumes input for the task
     * - volumes - Volumes are directories which may be used to share data between Executors
     * @param event The input event triggered when the volumes input changes
     */
    this.handleVolumesInput = (event) => {
      const inputElement = event.target;
      this.volumes = inputElement.value.split(",").map((volume) => volume.trim());
    };
    /**
     * Handles the change of the command input in the executor fields
     * @param event The input event triggered when the command input changes
     * @param executor The specific executor in the taskExecutors that is being changed
     */
    this.handleExecutorsCommandChange = (event, executor) => {
      const newCommands = event.target.value;
      executor.command = newCommands.split(",").map((c) => c.trim());
    };
    /**
     * Handles the change of the name field of env of the executor field
     * @param event The event triggered when the name field of env from any executor changes
     * @param executor The specific executor in the taskExecutors that is being changed
     * @param index The index of the env being changes if considered as an array
     */
    this.handleEnvNameChange = (event, executor, index) => {
      const newEnvName = event.target.value;
      const entries = Object.entries(executor.env);
      entries[index][0] = newEnvName;
      executor.env = Object.fromEntries(entries);
    };
    /**
     * Handles the change of the value field of env of the executor field
     * @param event The event triggered when the value field of env from any executor changes
     * @param executor The specific executor in the taskExecutors that is being changed
     * @param index The index of the env being changes if considered as an array
     */
    this.handleEnvValueChange = (event, executor, index) => {
      const newEnvValue = event.target.value;
      const entries = Object.entries(executor.env);
      entries[index][1] = newEnvValue;
      executor.env = Object.fromEntries(entries);
    };
    /**
     * This function handles input changes of stderr, stdout, stdin, workdir, image
     * @param event The event triggered when the value field changes
     * @param executor The specific executor in the taskExecutors that is being changed
     */
    this.handleExecutorsDataChange = (event, executor) => {
      const key = event.target.name;
      const data = event.target.value;
      executor[key] = data;
    };
    /**
     * Populate more executor fields
     */
    this.addExecutor = () => {
      this.taskExecutors.push({ ...executorTemplate });
      this.taskExecutorsLength += 1;
    };
    // Custom comparison function for executors
    this.areExecutorsEqual = (executor1, executor2) => {
      const check = executor1.image === executor2.image && executor1.stderr === executor2.stderr && executor1.stdin === executor2.stdin && executor1.stdout === executor2.stdout && executor1.workdir === executor2.workdir && JSON.stringify(executor1.command) === JSON.stringify(executor2.command);
      const keys1 = Object.keys(executor1.env);
      const keys2 = Object.keys(executor2.env);
      if (keys1.length !== keys2.length) {
        return false;
      }
      for (const key of keys1) {
        if (executor1.env[key] !== executor2.env[key]) {
          return false;
        }
      }
      return check;
    };
    this.addEnv = (executor) => {
      const updatedExecutors = this.taskExecutors.map((ex) => {
        if (this.areExecutorsEqual(ex, executor)) {
          const updatedEnv = { ...ex.env, "": "" };
          return { ...ex, env: updatedEnv };
        }
        return ex;
      });
      this.taskExecutors = updatedExecutors;
    };
    this.deleteEnv = (executor) => {
      const updatedExecutors = this.taskExecutors.map((ex) => {
        if (this.areExecutorsEqual(ex, executor)) {
          const entries = Object.entries(ex.env);
          entries.pop();
          const updatedEnv = Object.fromEntries(entries);
          return { ...ex, env: updatedEnv };
        }
        return ex;
      });
      this.taskExecutors = updatedExecutors;
    };
    /**
     * Remove one executors field
     */
    this.deleteExecutor = () => {
      if (this.taskExecutors.length > 1) {
        this.taskExecutors.pop();
        this.taskExecutorsLength -= 1;
      }
    };
    /**
     * Popuate more Input fields
     */
    this.addInput = () => {
      this.taskInput.push({ ...inputTemplate });
      this.taskInputLength += 1;
    };
    /**
     * Handles the path input for the Input fields
     * @param event The event triggered when the path field of the Input section changes
     * @param input The specific input of the taskInput that is being changed
     */
    this.handleInputPathChange = (event, input) => {
      const inputPathInput = event.target.value;
      input.path = inputPathInput;
    };
    /**
     * Handles the url input for the Input fields
     * @param event The event triggered when the url field of the Input section changes
     * @param input The specific input of the taskInput that is being changed
     */
    this.handleInputUrlChange = (event, input) => {
      const inputUrlInput = event.target.value;
      input.url = inputUrlInput;
    };
    /**
     * Remove one input field
     */
    this.deleteInput = () => {
      if (this.taskInput.length > 1) {
        this.taskInput.pop();
        this.taskInputLength -= 1;
      }
    };
    /**
     * Populate more Output fields
     */
    this.addOutput = () => {
      this.taskOutput.push({ ...outputTemplate });
      this.taskOutputLength += 1;
    };
    /**
     * Handles the path input for the Output fields
     * @param event The event triggered when the path field of the output section changes
     * @param output The specific output of the taskInput that is being changed
     */
    this.handleOutputPathChange = (event, output) => {
      const outputPathInput = event.target.value;
      output.path = outputPathInput;
    };
    /**
     * Handles the url input for the Output fields
     * @param event The event triggered when the url field of the output section changes
     * @param output The specific output of the taskInput that is being changed
     */
    this.handleOutputUrlChange = (event, output) => {
      const outputUrlInput = event.target.value;
      output.url = outputUrlInput;
    };
    /**
     * Handles the type input for the Output fields
     * @param event The event triggered when the type field of the output section changes
     * @param output The specific output of the taskInput that is being changed
     */
    this.handleOutputTypeChange = (event, output) => {
      const outputTypeInput = event.target.value;
      output.type = outputTypeInput;
    };
    /**
     * Remove one output field
     */
    this.deleteOutput = () => {
      if (this.taskOutput.length > 1) {
        this.taskOutput.pop();
        this.taskOutputLength -= 1;
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.taskExecutorsLength = this.taskExecutors.length;
    this.taskInputLength = this.taskInput.length;
    this.taskOutputLength = this.taskOutput.length;
  }
  /**
   * Checks if an obj is a valid JSON
   * @param obj Takes in an object to be checked
   * @returns boolean, true if obj is valid JSON and vice versa
   */
  isJSONValid(obj) {
    try {
      const jsonString = JSON.stringify(obj);
      JSON.parse(jsonString);
      return true;
    } catch (error) {
      return false;
    }
  }
};
__decorateClass([
  attr
], TESCreateRun.prototype, "baseURL", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "name", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "description", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "taskExecutors", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "taskExecutorsLength", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "taskInput", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "taskInputLength", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "taskOutput", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "taskOutputLength", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "cpu_cores", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "disk_gb", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "preemptible", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "ram_gb", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "zones", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "WORKFLOW_ID", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "PROJECT_GROUP", 2);
__decorateClass([
  attr
], TESCreateRun.prototype, "volumes", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "response", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "taskData", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "responseGot", 2);
__decorateClass([
  observable
], TESCreateRun.prototype, "isLoading", 2);
TESCreateRun = __decorateClass([
  customElement({
    name: "ecc-client-ga4gh-tes-create-run",
    template: tesCreateRun_template_default,
    styles: tesCreateRun_styles_default,
    shadowOptions: { mode: "open" }
  })
], TESCreateRun);

// src/components/tes-run/definition/tesRun.ts
import {
  FASTElement as FASTElement3,
  attr as attr3,
  customElement as customElement3,
  observable as observable3
} from "@microsoft/fast-element";

// src/components/tes-run/definition/tesRun.template.ts
import {
  provideFASTDesignSystem as provideFASTDesignSystem3,
  fastAccordionItem as fastAccordionItem3,
  fastSkeleton as fastSkeleton2,
  fastButton as fastButton2,
  fastBadge
} from "@microsoft/fast-components";
import { html as html3, when as when3, repeat as repeat3 } from "@microsoft/fast-element";

// src/components/tes-runs/definition/tesRuns.ts
import {
  FASTElement as FASTElement2,
  attr as attr2,
  customElement as customElement2,
  observable as observable2
} from "@microsoft/fast-element";

// src/components/tes-runs/definition/tesRuns.template.ts
import {
  provideFASTDesignSystem as provideFASTDesignSystem2,
  fastSkeleton,
  fastAccordion as fastAccordion2,
  fastAccordionItem as fastAccordionItem2,
  fastSelect,
  fastOption,
  fastTextField as fastTextField2
} from "@microsoft/fast-components";
import { html as html2, repeat as repeat2, when as when2 } from "@microsoft/fast-element";
provideFASTDesignSystem2().register(
  fastAccordion2(),
  fastAccordionItem2(),
  fastSkeleton(),
  fastSelect(),
  fastOption(),
  fastTextField2()
);
var template2 = html2`
  <div class="container">
    <div class="search">
      <fast-text-field
        placeholder="Search by name_prefix"
        :value=${(x) => x.searchInput}
        @input=${(x, c) => x.handleNameInput(c.event)}
      >
      </fast-text-field>
      <fast-select
        :value=${(x) => x.stateInput}
        @input=${(x, c) => x.handleStateInput(c.event)}
      >
        <fast-option value="ALL">ALL</fast-option>
        ${repeat2(
  () => stateOption,
  html2`<fast-option value=${(x) => x}>${(x) => x}</fast-option>`
)}
      </fast-select>
    </div>
    <div class="list">
      <fast-accordion>
        <!-- If data is being fetched or base URL not provided then load skeleton -->
        ${when2(
  (x) => x.isLoading || x.baseURL.length === 0,
  html2` ${repeat2(
    (x) => Array.from(Array(parseInt(x.pageSize, 10))),
    html2`
              <fast-accordion-item>
                <fast-skeleton
                  style="border-radius: 4px;height: 100%;margin-bottom: 10px;"
                  shape="rect"
                  slot="heading"
                ></fast-skeleton>
              </fast-accordion-item>
            `
  )}`
)}
        ${repeat2(
  (x) => x.data,
  html2`
            <ecc-client-ga4gh-tes-run
              class="run-item"
              baseURL=${(_, c) => c.parent.baseURL}
              id=${(x) => x.id}
              state=${(x) => x.state}
              admin=${(x) => x.admin}
            >
            </ecc-client-ga4gh-tes-run>
          `
)}
      </fast-accordion>
    </div>
    <div class="pagination">
      ${when2(
  (x) => x.isLoading,
  html2` ${repeat2(
    () => Array.from(Array(3)),
    html2`
            <fast-button appearance="outline">
              <fast-skeleton
                style="border-radius: 4px;height: 100%;margin-bottom: 10px;"
                shape="rect"
                slot="heading"
              ></fast-skeleton>
            </fast-button>
          `
  )}`
)}
      ${when2(
  (x) => !x.isLoading,
  html2`
          <fast-button
            appearance="neutral"
            ?disabled=${(x) => x.pageNumber === 1}
            @click=${(x) => x.handlePrev()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6"
            >
              <path
                d="M9.195 18.44c1.25.713 2.805-.19 2.805-1.629v-2.34l6.945 3.968c1.25.714 2.805-.188 2.805-1.628V8.688c0-1.44-1.555-2.342-2.805-1.628L12 11.03v-2.34c0-1.44-1.555-2.343-2.805-1.629l-7.108 4.062c-1.26.72-1.26 2.536 0 3.256l7.108 4.061z"
              />
            </svg>
          </fast-button>
          <fast-button appearance="outline" style="color:black"
            >${(x) => x.pageNumber}</fast-button
          >
          <fast-button
            appearance="neutral"
            ?disabled=${(x) => x.tokens[x.pageNumber + 1] === void 0}
            @click=${(x) => x.handleNext()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="w-6 h-6"
            >
              <path
                d="M5.055 7.06c-1.25-.714-2.805.189-2.805 1.628v8.123c0 1.44 1.555 2.342 2.805 1.628L12 14.471v2.34c0 1.44 1.555 2.342 2.805 1.628l7.108-4.061c1.26-.72 1.26-2.536 0-3.256L14.805 7.06C13.555 6.346 12 7.25 12 8.688v2.34L5.055 7.06z"
              />
            </svg>
          </fast-button>
        `
)}
    </div>
  </div>
`;
var tesRuns_template_default = template2;

// src/components/tes-runs/definition/tesRuns.styles.ts
import { css as css2 } from "@microsoft/fast-element";
var styles2 = css2`
  .container {
    display: block;
  }

  .search {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  fast-text-field {
    width: 100%;
  }

  fast-select {
    width: 25%;
  }

  .list {
    padding-bottom: 1rem;
  }

  .pagination {
    display: flex;
    justify-content: center;
    gap: 10px;
    width: 100%;
    align-items: center;
  }

  @media (max-width: 450px) {
    .search {
      flex-direction: column;
    }
    fast-select {
      width: 100%;
    }
  }
`;
var tesRuns_styles_default = styles2;

// src/components/tes-runs/definition/tesRuns.ts
var stateOption = [
  "UNKNOWN",
  "QUEUED",
  "INITIALIZING",
  "RUNNING",
  "PAUSED",
  "COMPLETE",
  "EXECUTOR_ERROR",
  "SYSTEM_ERROR",
  "CANCELED",
  "PREEMPTED",
  "CANCELING"
];
var TESRuns2 = class extends FASTElement2 {
  constructor() {
    super(...arguments);
    this.baseURL = "";
    this.admin = false;
    this.pageSize = 5;
    this.tokens = {};
    this.data = [];
    this.pageNumber = 1;
    this.searchInput = "";
    this.stateInput = "ALL";
    this.unfilterdData = {
      tasks: [],
      next_page_token: ""
    };
    this.isLoading = true;
    /**
     *Fetches data of pageSize length
     * @param token token for the next page for cache data
     * @param namePrefix takes in the filter value for name prefix
     */
    this.fetchData = async (token, namePrefix = "") => {
      this.isLoading = true;
      this.data = [];
      let newData = [];
      newData = await fetchTasks(
        this.baseURL,
        this.pageSize,
        token,
        "MINIMAL",
        namePrefix
      );
      if (newData && newData.tasks) {
        this.data = newData.tasks;
        this.unfilterdData = newData;
      }
      this.isLoading = false;
    };
    // Cache next click
    this.handleNext = async () => {
      this.stateInput = "ALL";
      const nextPageNumber = this.pageNumber + 1;
      this.pageNumber = nextPageNumber;
      const pageToken = this.tokens[this.pageNumber];
      await this.fetchData(pageToken, this.searchInput);
      this.tokens[nextPageNumber + 1] = this.unfilterdData.next_page_token;
    };
    // Handle prev click
    this.handlePrev = async () => {
      this.stateInput = "ALL";
      const prevPageNumber = this.pageNumber - 1;
      const prevPageToken = this.tokens[prevPageNumber];
      await this.fetchData(prevPageToken, this.searchInput);
      this.pageNumber -= 1;
    };
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.fetchData("");
    this.tokens[1] = "";
    this.tokens[2] = this.unfilterdData.next_page_token;
  }
  handleNameInput(event) {
    this.searchInput = event.target.value;
    this.pageNumber = 1;
    this.fetchData("", this.searchInput);
  }
  handleStateInput(event) {
    this.stateInput = event.target.value;
    if (this.stateInput === "ALL")
      this.data = this.unfilterdData.tasks;
    else {
      this.data = this.unfilterdData.tasks.filter(
        (task) => task.state === this.stateInput
      );
    }
  }
};
__decorateClass([
  attr2
], TESRuns2.prototype, "baseURL", 2);
__decorateClass([
  attr2
], TESRuns2.prototype, "admin", 2);
__decorateClass([
  attr2
], TESRuns2.prototype, "pageSize", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "tokens", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "data", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "pageNumber", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "searchInput", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "stateInput", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "unfilterdData", 2);
__decorateClass([
  observable2
], TESRuns2.prototype, "isLoading", 2);
TESRuns2 = __decorateClass([
  customElement2({
    name: "ecc-client-ga4gh-tes-runs",
    template: tesRuns_template_default,
    styles: tesRuns_styles_default
  })
], TESRuns2);

// src/components/tes-run/definition/tesRun.template.ts
provideFASTDesignSystem3().register(
  fastSkeleton2(),
  fastButton2(),
  fastBadge(),
  fastAccordionItem3({
    collapsedIcon: `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="16"
      fill="black"
      class="bi bi-arrows-expand"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8ZM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2ZM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10Z"
      />
    </svg>`,
    expandedIcon: `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="100%"
      fill="black"
      class="bi bi-arrows-collapse"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8Zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0Zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793Z"
      />
    </svg>`
  })
);
var template3 = html3`
  <fast-accordion-item @change=${(x) => x.handleFetch()}>
    <span slot="heading" class="slot-heading">
      ${(x) => html3`
        <div class="collapsed-container">
          <div class="right">
            <span class="id">
              <span class="title">RUN ID:</span>
              <span>${x.id}</span>
            </span>
          </div>
          <div class="left">
            <div class="status-badge">
              <div>
                <style>
                  /* For example purposes only. App authors need to define */
                  fast-badge {
                    --badge-fill-unknown: #aad3d3;
                    --badge-fill-complete: #4caf50;
                    --badge-fill-queued: #2196f3;
                    --badge-fill-initializing: #9c27b0;
                    --badge-fill-running: #ff5722;
                    --badge-fill-paused: #607d8b;
                    --badge-fill-system_error: #f44336;
                    --badge-fill-executor_error: #d32f2f;
                    --badge-fill-canceled: #795548;
                    --badge-fill-preempted: #00bcd4;
                    --badge-color-white: #ffffff;
                  }
                </style>
                ${repeat3(
  () => stateOption,
  html3`
                    ${when3(
    (thisState, c) => c.parent.state === thisState,
    html3`
                        <fast-badge
                          fill=${(value) => value.toLowerCase()}
                          color="white"
                          >${x.state}</fast-badge
                        >
                      `
  )}
                  `
)}
              </div>
            </div>
          </div>
        </div>
      `}
    </span>
    ${when3(
  (x) => x.isLoading,
  html3` <fast-skeleton
          style="border-radius: 4px; margin-top: 10px; height: 20px; width: 20%"
          shape="rect"
        ></fast-skeleton>
        <fast-skeleton
          style="border-radius: 4px; margin-top: 10px; height: 20px; width: 40%"
          shape="rect"
        ></fast-skeleton>
        <fast-skeleton
          style="border-radius: 4px; margin-top: 10px; height: 20px; width:25%"
          shape="rect"
        ></fast-skeleton>
        <fast-skeleton
          style="border-radius: 4px;height: 80px;margin-top: 20px;margin-bottom: 10px;"
          shape="rect"
        ></fast-skeleton>
        <fast-skeleton
          style="border-radius: 4px;height: 80px;margin-top: 20px;margin-bottom: 10px;"
          shape="rect"
        ></fast-skeleton>`
)}
    ${when3(
  (x) => !x.isLoading,
  html3`
        <div class="expanded-container">
          <div class="meta-data">
            <div class="meta-data-left">
              <div class="name">
                <span class="title"> Name: </span>
                ${(x) => x.data.name}
              </div>
              <div class="description">
                <span class="title"> Description: </span>
                ${(x) => x.data.description}
              </div>
              <div class="creation-time">
                <span class="title"> Creation Time: </span>
                ${(x) => x.data.creation_time}
              </div>
            </div>
            <div class="meta-data-right">
              <!-- All the buttons rendered here will need admin permission -->
              ${when3(
    (x) => x.state === "RUNNING" && x.admin === true,
    html3` <fast-button
                  class="delete-button"
                  @click=${(x) => x.handleDelete()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"
                    />
                    <path
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"
                    />
                  </svg>
                </fast-button>`
  )}
              <!-- If more cta are to be added that need admin permission, use admin === true with other respective checks -->
            </div>
          </div>
          <div class="executors">
            <div class="section-heading">
              <span class="title">Executors: </span>
            </div>
            ${repeat3(
    (x) => x.data.executors,
    html3`
                <div class="executor">
                  <div class="image">
                    <span class="title">Image: </span>
                    ${(executor) => executor.image}
                  </div>
                  <div class="command-list">
                    <span class="title">Commands: </span>

                    ${repeat3(
      (executor) => executor.command,
      html3`<li class="command">${(x) => x}</li>`
    )}
                  </div>
                </div>
              `
  )}
          </div>
          <div class="logs">
            <div class="section-heading">
              <span class="title"> Logs </span>
            </div>
            ${when3(
    (x) => x.data.logs && x.data.logs.length > 0,
    html3`
                ${repeat3(
      (x) => x.data.logs,
      html3`
                    <div class="log-entry">
                      <div class="start-time">
                        <span class="title">Start Time:</span> ${(x) => x.start_time}
                      </div>
                      <div class="end-time">
                        <span class="title">End Time:</span>
                        ${(x) => x.end_time}
                      </div>
                      ${when3(
        (x) => x.logs && x.logs.length > 0,
        html3`
                          <div class="stdout">
                            <span class="title">Stdout:</span>
                            ${(x) => x.logs[0].stdout}
                          </div>
                          <div class="exit-code">
                            <span class="title">Exit Code: </span>
                            ${(x) => x.logs[0].exit_code}
                          </div>
                        `
      )}
                      ${when3(
        (x) => x.metadata && x.metadata.USER_ID,
        html3`
                          <div class="user-id">
                            <span class="title">Metadata User ID: </span>
                            ${(x) => x.metadata.USER_ID}
                          </div>
                        `
      )}
                    </div>
                  `
    )}
              `
  )}
          </div>
        </div>
      `
)}
  </fast-accordion-item>
`;
var tesRun_template_default = template3;

// src/components/tes-run/definition/tesRun.styles.ts
import { css as css3 } from "@microsoft/fast-element";
var styles3 = css3`
  .slot-heading {
    color: black;
  }

  .collapsed-container {
    display: flex;
    border: none;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .right {
    margin-right: 10px;
  }

  .left {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .id {
    display: flex;
    align-items: center;
  }

  .title {
    margin-right: 5px;
    font-weight: bold;
    font-size: 0.8rem;
  }

  .delete-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 10px;
    transition: color 0.2s ease, transform 0.2s ease;
  }

  .delete-icon:hover {
    transform: scale(1.1);
  }

  .expanded-container {
    padding: 1rem;
    color: black;
  }

  .meta-data {
    margin-bottom: 1rem;
    display: flex;
    justify-content: space-between;
  }

  .meta-data-right {
    display: flex;
    gap: 0.2rem;
  }

  .name,
  .description,
  .creation-time {
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .section-heading {
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .executor {
    padding: 0.5rem;
    margin-bottom: 1rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .image {
    margin-bottom: 0.5rem;
  }

  .command-list {
    margin-top: 0.5rem;
  }

  .command {
    padding: 0.2rem 1rem;
  }

  .log-entry {
    padding: 0.5rem;
    margin-bottom: 1rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .start-time,
  .end-time {
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .stdout,
  .exit-code,
  .user-id {
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  @media only screen and (max-width: 600px) {
    .meta-data {
      display: flex;
      flex-direction: column-reverse;

      .meta-data-right {
        justify-content: end;
        margin-bottom: 0.4rem;
      }
    }
  }
`;
var tesRun_styles_default = styles3;

// src/components/tes-run/definition/tesRun.ts
var TESRun = class extends FASTElement3 {
  constructor() {
    super(...arguments);
    this.baseURL = "";
    this.id = "";
    this.admin = false;
    this.state = "";
    this.isLoading = true;
    this.data = {
      id: this.id,
      state: this.state,
      name: "",
      description: "",
      creation_time: "",
      executors: [],
      logs: []
    };
    // Handles deletion of this task
    this.handleDelete = async () => {
      if (this.baseURL.length !== 0)
        await deleteTask(this.baseURL, this.id);
    };
    // Fetched the task with this ID
    this.handleFetch = async () => {
      if (this.isLoading && this.baseURL.length !== 0) {
        this.data = await fetchTask(this.baseURL, this.id);
        this.isLoading = false;
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
};
__decorateClass([
  attr3
], TESRun.prototype, "baseURL", 2);
__decorateClass([
  attr3
], TESRun.prototype, "id", 2);
__decorateClass([
  attr3
], TESRun.prototype, "admin", 2);
__decorateClass([
  attr3
], TESRun.prototype, "state", 2);
__decorateClass([
  observable3
], TESRun.prototype, "isLoading", 2);
__decorateClass([
  observable3
], TESRun.prototype, "data", 2);
TESRun = __decorateClass([
  customElement3({
    name: "ecc-client-ga4gh-tes-run",
    template: tesRun_template_default,
    styles: tesRun_styles_default,
    shadowOptions: { mode: "open" }
  })
], TESRun);

// src/components/tes-service/definition/tesService.ts
import {
  FASTElement as FASTElement4,
  attr as attr4,
  customElement as customElement4,
  observable as observable4
} from "@microsoft/fast-element";

// src/components/tes-service/definition/tesService.template.ts
import { html as html4, repeat as repeat4, when as when4 } from "@microsoft/fast-element";
var conditionalRender = () => html4`${when4(
  (val) => Array.isArray(val[1]),
  html4`${(val) => ArrayTemplate(val)} `
)}
${when4(
  (val) => typeof val[1] === "object" && val[1] !== null && !Array.isArray(val[1]),
  html4` ${(val) => ObjectTemplate(val)} `
)}`;
var OtherTemplate = (x) => html4`
  <div class="template-container container key-value">
    <div class="key">${x[0]}</div>
    <div class="value">${x[1]}</div>
  </div>
`;
var ArrayTemplate = (x) => html4`
  <div class="template-container">
    <div class="container array-container">
      <div class="key">${x[0]}</div>
      <div class="value array-value">
        ${repeat4(
  (arr) => arr[1],
  html4`
            ${conditionalRender()}
            ${when4(
    (val) => typeof val[1] !== "object",
    html4` ${(val) => val} `
  )}
          `
)}
      </div>
    </div>
  </div>
`;
var ObjectTemplate = (x) => html4`
  <div class="template-container">
    <div class="obj-name">${x[0]}:</div>
    <div class="object-container">
      <div class="value object-value">
        ${when4(
  (obj) => Object.entries(obj[1]).length > 0,
  html4`
            ${repeat4(
    (val) => Object.entries(val[1]),
    html4`
                ${conditionalRender()}
                ${when4(
      (val) => typeof val[1] !== "object",
      html4` ${(val) => OtherTemplate(val)} `
    )}
              `
  )}
          `
)}
      </div>
    </div>
  </div>
`;
var template4 = html4`
  <div class="template-container">
    <div class="Outer-container">
      ${when4(
  (x) => Object.entries(x.data).length > 0,
  html4`
          ${repeat4(
    (x) => Object.entries(x.data),
    html4`
              ${conditionalRender()}
              ${when4(
      (val) => typeof val[1] !== "object",
      html4` ${(val) => OtherTemplate(val)} `
    )}
            `
  )}
        `
)}
    </div>
  </div>
`;
var tesService_template_default = template4;

// src/components/tes-service/definition/tesService.styles.ts
import { css as css4 } from "@microsoft/fast-element";
var styles4 = css4`
  /* Common styles for all containers */
  .container {
    display: flex;
  }

  .template-container {
    border: 1px solid #ccc;
    margin: 0.4rem;
    padding: 0.3rem;
    border-radius: 0.4rem;
  }

  /* Styling for the main container */
  .outer-container {
  }

  /* Styling for arrays */
  .array-container {
  }

  .array-value {
    display: flex;
    flex-direction: column;
  }

  /* Styling for objects */
  .object-container {
  }

  .object-value {
  }

  .obj-name {
    font-weight: bold;
    flex-basis: 30%;
    text-transform: uppercase;
  }

  /* Styling for key-value pairs */
  .key-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .key {
    font-weight: bold;
    font-size: small;
    flex-basis: 30%;
    text-transform: uppercase;
  }

  .value {
    font-size: small;
    flex-basis: 70%;
  }

  /* Responsive styles for mobile devices */
  @media (max-width: 550px) {
    .outer-container {
    }

    .container {
      flex-direction: column;
    }

    .key-value {
      display: block;
    }

    .key {
      font-size: smaller;
    }

    .value {
      font-size: smaller;
    }
  }
`;
var tesService_styles_default = styles4;

// src/components/tes-service/definition/tesService.ts
var TESService = class extends FASTElement4 {
  constructor() {
    super(...arguments);
    this.baseURL = "";
    this.data = {};
  }
  async connectedCallback() {
    super.connectedCallback();
    this.data = await fetchService(this.baseURL);
  }
};
__decorateClass([
  attr4
], TESService.prototype, "baseURL", 2);
__decorateClass([
  observable4
], TESService.prototype, "data", 2);
TESService = __decorateClass([
  customElement4({
    name: "ecc-client-ga4gh-tes-service",
    template: tesService_template_default,
    styles: tesService_styles_default,
    shadowOptions: { mode: "open" }
  })
], TESService);
export {
  TESCreateRun,
  TESRun,
  TESRuns2 as TESRuns,
  TESService
};
